// Single source of truth for demo profile data
// Used for: demo URL parameters (?demo=delhi), scan demo button, and "no user found" scenarios

export const DEMO_PROFILE_ID = "demo-amit";

export const DEMO_OWNER_INFO_MESSAGE = `Same profile with your details will appear here on scanning the sticker.

Buy QR stickers, create account on Metefy and apply them on your products.`;

export const DEMO_OWNER_PRODUCTS_MESSAGE = "Use Stickers on Metro Card, Laptop, Phone, Charger, Vehicles, Helmet, etc.";

export const DEMO_LOCKED_PRODUCTS_MESSAGE = "Enter the QR password to view this owner’s products list.";

export const DEMO_PROFILE = {
  id: DEMO_PROFILE_ID,
  first_name: "Amit",
  last_name: "building Metefy",
  x_username: "whocares0412",
  bio: DEMO_OWNER_INFO_MESSAGE,
  heading: null,
  site_link: null,
  mask_bio: false,
  metro_card_number: "84435233",
  vehicle_number: null,
  created_at: new Date().toISOString(),
  updated_at: new Date().toISOString(),
  show_email: false,
  show_mobile: false,
  metefy_token: "981210013812",
  photo_url: "https://lh3.googleusercontent.com/a/ACg8ocLMbVYDT-HiZfhrUD4_e1D6J9Ldk-E3F4Q7365r8j5WJkb05_ly=s96-c",
  social_sms: null,
  social_call: null,
  social_telegram: null,
  social_whatsapp: null,
  use_social_icons: false,
  metro_password_mode: "disabled",
  metro_card_password: null,
  vehicle_password_mode: "disabled",
  vehicle_password: null
};

// Helper to get a fresh demo profile (with updated timestamps)
export const getDemoProfile = () => ({
  ...DEMO_PROFILE,
  created_at: new Date().toISOString(),
  updated_at: new Date().toISOString()
});

